import { useEffect, useState } from "react";

export type Lang = "en" | "fr";

const STORAGE_KEY = "acquiz_lang";

export function useLang() {
  const [lang, setLang] = useState<Lang>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return (stored === "fr" || stored === "en") ? (stored as Lang) : "fr";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return { lang, setLang } as const;
}
